import gsap, { Power1 } from 'gsap';
import * as Header from '../components/header';

/**
 * @param {*} nodeElement - every possible html element
 * @param {*} substractOrAdditionToScrollOffset - pixels that should be added or substracted from final offsetTop
 * @param {*} scrollingTime - default 900 ms
 */
export function scrollToTarget(nodeElement, substractOrAdditionToScrollOffset = 0, scrollingTime = 900) {
    if (!nodeElement) return;

    const targetOffset = calculateOffsetTop(nodeElement);
    animateScrolling(targetOffset + substractOrAdditionToScrollOffset, scrollingTime);
}

export function scrollToAnchor(e, link) {
    const exludedLinks = ['#easy-popup-', '#skipNavigation', '#ccSkipContent'];

    if (!link.hash || link.dataset?.fslightbox || exludedLinks.some((value) => link.hash.startsWith(value))) {
        return;
    }

    const target = document.querySelector(link.hash);

    if (!location.pathname.includes(link.pathname) || !target) return;

    if (e) e.preventDefault();
    scrollToTarget(target);
}

export function isInViewport(element) {
    const rect = element.getBoundingClientRect();

    return (
        rect.top >= Header.getInnerHeight() &&
        rect.left >= 0 &&
        rect.bottom <= window.innerHeight &&
        rect.right <= window.innerWidth
    );
}

function calculateOffsetTop(target) {
    const targetStyles = getComputedStyle(target);

    let marginTop = Number.parseInt(targetStyles.marginTop) / 2;
    marginTop = marginTop < 0 ? 0 : marginTop;

    const endScrollOffset = target.getBoundingClientRect().top + document.documentElement.scrollTop;

    const headerHeight = endScrollOffset > Header.getFixedPosition() ? Header.getInnerHeight() : 0;

    return endScrollOffset - headerHeight - marginTop + 1;
}

function animateScrolling(targetOffset, scrollingTime) {
    gsap.to('html, body', {
        scrollTop: targetOffset,
        duration: scrollingTime / 1000,
        overwrite: true,
        ease: Power1.easeInOut,
    });
}
